<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col v-if="!haveAClient" xs="12" md="6" lg="3">
                        <app-autocomplete
                            placeholder="Cliente"
                            :items="clients"
                            v-model="selectedClient"
                        />
                    </b-col>
                    <b-col align-h="center" v-if="!haveAClient" cols="12" md="4" lg="3">
                        <app-form-select-input placeholder="Sede" :options="venues" v-model="filters.venue"></app-form-select-input>
                    </b-col>
                    <b-col align-h="center" v-if="!haveAClient" cols="12" md="4" lg="3">
                        <app-form-select-input placeholder="Estructura" :options="accessPoints" v-model="filters.structure"></app-form-select-input>
                    </b-col>
                    <b-col cols="12" md="4" lg="3">
                        <app-autocomplete
                            placeholder="Usuario que registro"
                            :items="authors"
                            v-model="selectedUser"
                        /> 
                    </b-col>
                    <b-col cols="12" md="4" lg="3">
                        <app-form-text-input 
                            v-model="filters.plate"
                            placeholder="Placa"
                        />
                    </b-col>
                    <b-col cols="12" md="auto" class="mt-2 mt-md-0">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="auto" class="mt-2 mt-md-0">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                    <b-col v-if="showExport" cols="12" md="auto" class="mt-2 mt-md-0">
                        <b-button variant="outline-primary" class="btn-block" @click="emitExport">
                            <i class="fa fa-download" aria-hidden="true"></i> Exportar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../../../../components/UI/Controls/AutocompleteV2/Autocomplete.vue';
import structuresRepository from '../../../../../../repositories/structures.repository.js';
import venuesRepository from '../../../../../../repositories/venues.repository';
import { mapGetters } from 'vuex';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        authors: {
            type: Array
        },
        haveAClient :{
            type: Boolean
        },
        showExport: {
            type: Boolean,
            default: true,
        },
    },
    data(){
        return {
            accessPoints: [],
            venues: [],
            filters: {
                registered_by: '',
                client: '',
                venue: '',
                structure: '',
                plate: ''
            },
            selectedUser: '',
            selectedClient: '',
        }
    },
    computed: {
        ...mapGetters(['clients'])
    },
    watch:{
        selectedUser(val){
            if(!val){
                this.filters.registered_by = '';
                this.selectedUser = '';
            }else{
                this.filters.registered_by = val.id;
            }
        },
        selectedClient(val){
            if(!val){
                this.filters.client= '';
                this.selectedClient = '';
            }else{
                this.loadVenues(val.id);
                this.loadAccessPoints(val.id);
                this.filters.client = val.id;
            }
        }
    },
    methods: {
        loadAccessPoints(clientId){
            const sr = {...structuresRepository};
            sr.accessPointsByClient(clientId)
            .then(data => this.accessPoints = data)
            .catch(error => toastr.error('Error al cargar los puntos de acceso en recomendaciones de seguridad'));
        },
        loadVenues(clientId){
            const vr = {...venuesRepository};
            vr.loadVenuesByClient(clientId, '', '')
            .then(data => this.venues = data)
            .catch(error => toastr.error('Error al cargar los puntos de acceso en recomendaciones de seguridad'));
        },
        clearFilters(){
            this.selectedUser = '';
            this.selectedClient= '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        },
        emitExport() {
            this.$emit('export', Object.assign({}, this.filters));
        }
    },
    created(){
        this.load('clients');
    }
}
</script>

